// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components

// ----------------------------------------------------------------------

// const icon = (name) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

const icon = (name) => (
  <img alt={name} src={`/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  catering: icon("ic_round_food_bank"),
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  coupon: icon("ic_coupon"),
  notification: icon("ic_notification"),
  profile: icon("ic_profile"),
  pages: icon("ic_pages"),
  blogs: icon("ic_blogs"),
  settings: icon("ic_settings"),
  tripHour: icon("ic_trip_hr"),
  vehicle: icon("ic_vehicle"),
  reports: icon("ic_reports"),
  contacts: icon("ic_contacts"),
  testimonials: icon("ic_testimonials"),
  school: icon("ic_school"),
  dress: icon("ic_dress"),
  size: icon("ic_size"),
  category: icon("ic_category"),
  house: icon("ic_house"),
  product: icon("ic_product"),
  orders: icon("ic_order"),
  gallery: icon("ic_gallery"),
  notice: icon("ic_notice"),
  pos: icon("ic_cart"),
  tag: icon("ic_tag"),
  rider: icon("ic_rider"),
  file: icon("ic_file"),
};

const navConfig = [
  // analytics
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.dashboard,
        icon: ICONS.dashboard,
      },
      { title: "Profile", path: PATH_DASHBOARD.profile, icon: ICONS.profile },
      { title: "POS", path: PATH_DASHBOARD.pos, icon: ICONS.pos },

      {
        title: "Notifications",
        path: PATH_DASHBOARD.notification,
        icon: ICONS.notification,
      },
    ],
  },

  // TODO: stock management
  {
    subheader: "Stock Management",
    items: [
      {
        title: "Stock Histories",
        icon: ICONS.file,
        children: [
          {
            title: "All",
            path: PATH_DASHBOARD.stockHistories,
          },
        ],
      },
    ],
  },

  // TODO: meta
  {
    subheader: "Meta",
    items: [
      {
        title: "Pages",
        path: PATH_DASHBOARD.meta.pages.list,
        icon: ICONS.blogs,
      },
      {
        title: "Site map",
        path: PATH_DASHBOARD.meta.sitemap.root,
        icon: ICONS.file,
      },
    ],
  },

  // TODO: order management
  {
    subheader: "Order Management",
    items: [
      {
        title: "Orders",
        path: PATH_DASHBOARD.orders.root,
        icon: ICONS.file,
        children: [
          {
            title: "Orders List",
            path: PATH_DASHBOARD.orders.list,
          },
          {
            title: "Calendar View",
            path: PATH_DASHBOARD.orders.calendar,
          },
        ],
      },
      {
        title: "Promo Codes",
        path: PATH_DASHBOARD.promoCodes.list,
        icon: ICONS.coupon,
      },
    ],
  },

  // TODO: products
  {
    subheader: "Products",
    items: [
      {
        title: "Products",
        path: PATH_DASHBOARD.products.root,
        icon: ICONS.product,
        children: [
          {
            title: "Orderable list",
            path: PATH_DASHBOARD.products.orderableList,
          },
          {
            title: "Non Orderable list",
            path: PATH_DASHBOARD.products.nonOrderableList,
          },
          {
            title: "Product list",
            path: PATH_DASHBOARD.products.list,
          },
          {
            title: "Add Product",
            path: PATH_DASHBOARD.products.add,
          },
        ],
      },
    ],
  },

  // TODO: entriessss
  {
    subheader: "Pumpernickel Entries",
    items: [
      {
        title: "Categories",
        path: PATH_DASHBOARD.entries.categories.list,
        icon: ICONS.category,
      },
      {
        title: "Assign Printers",
        path: PATH_DASHBOARD.entries.categories.assignPrinter,
        icon: ICONS.category,
      },
      {
        title: "Galleries",
        path: PATH_DASHBOARD.entries.galleries.list,
        icon: ICONS.gallery,
      },
    ],
  },

  // TODO: contents
  {
    subheader: "Contents",
    items: [
      {
        title: "Blogs",
        path: PATH_DASHBOARD.contents.blogs.list,
        icon: ICONS.blogs,
        // children: [
        //   {
        //     title: "Blogs list",
        //     path: PATH_DASHBOARD.contents.blogs.list,
        //   },
        //   {
        //     title: "Add Blog",
        //     path: PATH_DASHBOARD.contents.blogs.add,
        //   },
        // ],
      },
      {
        title: "Caterings",
        path: PATH_DASHBOARD.contents.catering.root,
        icon: ICONS.catering,
        children: [
          {
            title: "Caterings list",
            path: PATH_DASHBOARD.contents.catering.list,
          },
          {
            title: "Catering Form Data",
            path: PATH_DASHBOARD.contents.catering.formData,
          },
        ],
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: "management",
    items: [
      {
        title: "Notices",
        path: PATH_DASHBOARD.notices.list,
        icon: ICONS.notice,
      },
      {
        title: "Help and Support",
        path: PATH_DASHBOARD.manage.root,
        icon: ICONS.user,
        children: [{ title: "FAQs", path: PATH_DASHBOARD.manage.faqs.list }],
      },
      // {
      //   title: "Registered Users",
      //   path: PATH_DASHBOARD.users.list,
      //   icon: ICONS.user,
      // },
      {
        title: "Contacts",
        path: PATH_DASHBOARD.contacts.root,
        icon: ICONS.contacts,
        children: [
          {
            title: "Contacts list",
            path: PATH_DASHBOARD.contacts.list,
          },
          {
            title: "Add Contact",
            path: PATH_DASHBOARD.contacts.add,
          },
        ],
      },
      {
        title: "Activity Logs",
        path: PATH_DASHBOARD.activityLogs,
        icon: ICONS.reports, // Using 'reports' icon as it fits well
      },
      {
        title: "Cart Popup",
        path: PATH_DASHBOARD.cartModal,
        icon: ICONS.notice,
      },
      {
        title: "Settings",
        path: PATH_DASHBOARD.settings,
        icon: ICONS.settings,
      },
    ],
  },

  // crm user
  {
    subheader: "crm",
    items: [
      {
        title: "Users",
        path: PATH_DASHBOARD.users.list,
        icon: ICONS.user,
      },
      {
        title: "Tags",
        path: PATH_DASHBOARD.contents.tags.list,
        icon: ICONS.tag,
      },
      {
        title: "Riders",
        path: PATH_DASHBOARD.riders.list,
        icon: ICONS.rider,
      },
      {
        title: "Orders Status",
        path: PATH_DASHBOARD.crmorder.list,
        icon: ICONS.orders,
      },
    ],
  },
];

export default navConfig;
